
import createIconComponent from './utils/createIconComponent';
import React from 'react';
var IconButtonStop = createIconComponent({ fillContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 24A12 12 0 100 12a12.013 12.013 0 0012 12zM7.5 9A1.5 1.5 0 019 7.5h6A1.5 1.5 0 0116.5 9v6a1.5 1.5 0 01-1.5 1.5H9A1.5 1.5 0 017.5 15z' })
  ), lightContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M8.5 16.999c-.827 0-1.5-.673-1.5-1.5v-7c0-.827.673-1.5 1.5-1.5h7c.827 0 1.5.673 1.5 1.5v7c0 .827-.673 1.5-1.5 1.5h-7zm0-9a.5.5 0 00-.5.5v7a.5.5 0 00.5.5h7a.5.5 0 00.5-.5v-7a.5.5 0 00-.5-.5h-7z' }),
    React.createElement('path', { d: 'M12 23.999c-6.617 0-12-5.383-12-12s5.383-12 12-12 12 5.383 12 12-5.383 12-12 12zm0-23c-6.065 0-11 4.935-11 11s4.935 11 11 11 11-4.935 11-11-4.935-11-11-11z' })
  ), regularContent: React.createElement(
    'g',
    null,
    React.createElement('path', { d: 'M12 23.998c-6.617 0-12-5.383-12-12s5.383-12 12-12 12 5.383 12 12-5.383 12-12 12zm0-22.5c-5.79 0-10.5 4.71-10.5 10.5s4.71 10.5 10.5 10.5 10.5-4.71 10.5-10.5-4.71-10.5-10.5-10.5z' }),
    React.createElement('path', { d: 'M9 16.498c-.827 0-1.5-.673-1.5-1.5v-6c0-.827.673-1.5 1.5-1.5h6c.827 0 1.5.673 1.5 1.5v6c0 .827-.673 1.5-1.5 1.5H9zm0-1.5h6v-6H9v6z' })
  ), height: undefined, width: undefined, viewBox: "0 0 24 24" });
IconButtonStop.displayName = 'IconButtonStop';
export default IconButtonStop;